import React from 'react';
import { X, Lightbulb, TrendingUp, Clock, AlertTriangle, MapPin } from 'lucide-react';

const TodaysInsights = ({ insights, isEmbedded = false, onClose }) => {
    // Default mock insights if none provided
    const defaultInsights = insights || [
        { icon: TrendingUp, text: 'Lead #1 has 95% conversion probability', type: 'success' },
        { icon: Clock, text: 'Best visit time: 10:00 AM - 2:00 PM', type: 'info' },
        { icon: AlertTriangle, text: 'Avoid traffic on Route 7 after 4 PM', type: 'warning' },
        { icon: MapPin, text: '3 leads near your current location', type: 'info' }
    ];

    if (isEmbedded) {
        return (
            <div className="w-full bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                <div className="p-4 space-y-3">
                    {defaultInsights.map((insight, index) => {
                        const Icon = insight.icon;
                        const colorClasses = {
                            success: 'text-emerald-600 bg-emerald-50',
                            warning: 'text-orange-600 bg-orange-50',
                            info: 'text-blue-600 bg-blue-50',
                            default: 'text-gray-600 bg-gray-50'
                        };
                        const colors = colorClasses[insight.type] || colorClasses.default;

                        return (
                            <div
                                key={index}
                                className={`flex items-start gap-3 p-3 rounded-lg ${colors}`}
                            >
                                <Icon className="w-5 h-5 flex-shrink-0 mt-0.5" />
                                <p className="text-sm font-medium leading-relaxed">
                                    {insight.text}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    // Panel overlay version (not embedded)
    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-40 flex items-start justify-center p-4" onClick={onClose}>
            <div
                className="bg-white rounded-xl shadow-2xl w-full max-w-2xl mt-4 md:mt-48 overflow-hidden"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="bg-gradient-to-r from-blue-500 to-purple-500 p-4 text-white flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <Lightbulb className="w-6 h-6" />
                        <h3 className="text-lg font-bold">Today's Insights</h3>
                    </div>
                    <button
                        onClick={onClose}
                        className="hover:bg-white hover:bg-opacity-20 p-2 rounded-lg transition-colors"
                    >
                        <X className="w-5 h-5" />
                    </button>
                </div>
                <div className="p-6 space-y-4 max-h-[70vh] overflow-y-auto">
                    {defaultInsights.map((insight, index) => {
                        const Icon = insight.icon;
                        const colorClasses = {
                            success: 'text-emerald-600 bg-emerald-50',
                            warning: 'text-orange-600 bg-orange-50',
                            info: 'text-blue-600 bg-blue-50',
                            default: 'text-gray-600 bg-gray-50'
                        };
                        const colors = colorClasses[insight.type] || colorClasses.default;

                        return (
                            <div
                                key={index}
                                className={`flex items-start gap-4 p-4 rounded-lg ${colors}`}
                            >
                                <Icon className="w-5 h-5 flex-shrink-0 mt-0.5" />
                                <p className="text-sm font-medium">{insight.text}</p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default TodaysInsights;
